import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { AbsoluteWhiteColors } from '@picsart/design-system/foundation/colors';
import { Effects } from '@picsart/design-system/foundation/effects';
import { Easings } from '@picsart/design-system/foundation/easings';
import {
  canHover,
  canTouch,
} from '@picsart/design-system/styleUtils/hoverTouch';
import isNativeMobile from '@/utils/platform/isNativeMobile';

// Card-internal stacking order. DS `StackingContext` tokens are app-level
// (>=1000); the card subtree keeps its own small layer indices. The actions
// row sits at the top overlay layer; CardActions renders after CardOverlays
// in the DOM so it paints above sibling overlays at the same z value.
const CARD_Z_ACTIONS = 5;

const useStyles = createUseStyles(
  {
    actionsContainer: {
      position: 'absolute',
      bottom: Spacings.s8,
      left: Spacings.s8,
      right: Spacings.s8,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: Spacings.s4,
      opacity: isNativeMobile() ? 1 : 0,
      transition: `opacity 0.2s ${Easings.easeOut}`,
      zIndex: CARD_Z_ACTIONS,
      // Fix iOS Safari stacking context bug: actions disappear after scrolling
      // when parent has contain: 'layout style paint'. isolation: 'isolate'
      // creates an explicit stacking context that iOS properly tracks.
      isolation: 'isolate',
      willChange: 'opacity',
      // Always show on touch devices
      [canTouch]: {
        opacity: 1,
      },
    },
    actionsContainerVisible: {
      opacity: 1,
    },
    group: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: Spacings.s4,
    },
    iconButton: {
      width: Spacings.s32,
      height: Spacings.s32,
      flex: `0 0 ${Spacings.s32}`,
      borderRadius: CornerRadius.circle,
      backgroundColor: Effects.alpha50,
      color: AbsoluteWhiteColors.base.default,
      border: 'none',
      [canHover]: {
        '&:hover': {
          backgroundColor: Effects.alpha80,
        },
      },
    },
  },
  { name: 'card-actions' }
);

export default useStyles;
